<template>
	<div id="wrapper">
		<PageSider></PageSider>
		<!--右侧部分开始-->
		<div id="page-wrapper" class="gray-bg dashbard-1">
			<PageHeader></PageHeader>
	    <breadcrumbs />
			<div class="row J_mainContent" id="content-main" style="height:calc(100% - 118px);overflow-y:auto;">
				<div class="wrapper wrapper-content animated fadeInRight">
					<router-view></router-view>
				</div>
			</div>
			<PageFooter></PageFooter>
		</div>
	</div>
</template>

<script>
	import PageSider from './PageSider.vue'
	import PageHeader from './PageHeader.vue'
	import PageFooter from './PageFooter.vue'
	import Breadcrumbs from '../../components/Breadcrumbs'

	export default {
		name: 'home',
		components: {
			PageSider,
			PageHeader,
			PageFooter,
			Breadcrumbs
		}
	}
</script>
